import { type ApplePayDialogContext } from '@cart-services/hooks/useApplePayDialogActions'
import { DialogApplePayConfirm } from '@cart-ui/DialogApplePayConfirm/DialogApplePayConfirm'
import { type CountryCode } from '@constants'
import { type CheckoutPayApplePayModule } from '@payments'
import { useFpB2bApplePayDialogFlow } from '../../fp-b2b-shared/hooks/useFpB2bApplePayDialogFlow'

export interface StmApplePayDialogProps {
  context: ApplePayDialogContext
  paymentModule: CheckoutPayApplePayModule
  countryCode: CountryCode
  onClose: () => void
  onError?: (error: unknown) => void
}

export const StmApplePayDialog = ({
  context,
  paymentModule,
  countryCode,
  onClose,
  onError,
}: StmApplePayDialogProps) => {
  const { mountApplePayButton, awaitAndExecutePayment, cancelInFlight, isExecuting } = useFpB2bApplePayDialogFlow({
    paymentModule,
    countryCode,
  })
  return (
    <DialogApplePayConfirm
      context={context}
      onClose={onClose}
      onError={onError}
      mountApplePayButton={mountApplePayButton}
      awaitAndExecutePayment={awaitAndExecutePayment}
      cancelInFlight={cancelInFlight}
      isExecuting={isExecuting}
    />
  )
}
